import { contactCard } from '../../../shared';

export const buyerCard = contactCard(
  'buySideContacts.buyersX',
  'counterpartyClient',
);
